// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';

// const CustomerHeader = () => {
//     const navigate = useNavigate();
//     const [showProfileDropdown, setShowProfileDropdown] = useState(false);

//     const toggleProfileDropdown = () => {
//         setShowProfileDropdown(!showProfileDropdown);
//     };

//     const handleLogout = () => {
//         // Add logout logic here (clear tokens, etc.)
//         navigate('/');
//     };

//     const handleProfileClick = () => {
//         navigate('/customer/profile');
//         setShowProfileDropdown(false);
//     };


//     const handleChangePassword = () => {
//         navigate('/customer/changepassword');
//         setShowProfileDropdown(false);
//     };

//     const handleFavoritesClick = () => {
//         navigate('/customer/favorites');
//         setShowProfileDropdown(false);
//     };

//     return (
//         <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-3">
//             <div className="container">
//                 {/* Brand Logo - Customer Style */}
//                  <Link className="navbar-brand d-flex align-items-center" to="/customer/orders">
                                                       
//                                                        {/* MF MONOGRAM */}
//                                                        <svg
//                                                            width="52"
//                                                            height="52"
//                                                            viewBox="0 0 180 120"
//                                                            xmlns="http://www.w3.org/2000/svg"
//                                                            style={{ marginRight: '5px' }}
//                                                        >
//                                                            <text
//                                                                x="0"
//                                                                y="90"
//                                                                fontFamily="Playfair Display, Didot, serif"
//                                                                fontSize="96"
//                                                                fontWeight="700"
//                                                                letterSpacing="-10"
//                                                                fill="#111"
//                                                            >
//                                                                MF
//                                                            </text>
//                                                        </svg>
                               
//                                                        {/* WORDMARK */}
//                                                        <div className="d-flex flex-column">
//                                                            <span
//                                                                style={{
//                                                                    fontSize: '1.05rem',
//                                                                    fontWeight: '500',
//                                                                    letterSpacing: '0.35rem',
//                                                                    color: '#111',
//                                                                    lineHeight: '1.1'
//                                                                }}
//                                                            >
//                                                                MUNNY FINDS
//                                                            </span>
                               
//                                                            {/* <span
//                                                                style={{
//                                                                    fontSize: '0.55rem',
//                                                                    letterSpacing: '0.25rem',
//                                                                    fontWeight: '600',
//                                                                    color: '#6b7280',
//                                                                    marginTop: '2px'
//                                                                }}
//                                                            >
//                                                                BEAUTY & CARE
//                                                            </span> */}
//                                                             <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.6rem', letterSpacing: '0.1rem' }}>Customer Control</span>
//                                                        </div>
                               
//                                                    </Link>
                               

//                 <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#customerNavbar">
//                     <span className="navbar-toggler-icon"></span>
//                 </button>

//                 <div className="collapse navbar-collapse" id="customerNavbar">
//                     <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3">
//                         {/* Navigation Links for Customer */}
//                         {/* <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark" to="/customer/dashboard">
//                                 <i className="ri-dashboard-line me-1"></i> Dashboard
//                             </Link>
//                         </li> */}
//                          <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark" to="/customer/orders">
//                                 <i className="ri-calendar-line me-1"></i> My Orders
//                             </Link>
//                         </li>
//                          <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark" to="/customer/appointments">
//                                 <i className="ri-calendar-line me-1"></i> My Appointments
//                             </Link>
//                         </li>
//                          <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark" to="/customer/products/search">
//                                 <i className="ri-store-2-line me-1"></i> Products
//                             </Link>
//                         </li>
                       
                       
//                         <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark" to="/customer/service">
//                                 <i className="ri-service-line me-1"></i> Services
//                             </Link>
//                         </li>
//                     <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark" to="/customer/salons/search">
//                                 <i className="ri-store-2-line me-1"></i> Find Salons
//                             </Link>
//                         </li>
                       
                      
//                     </ul>
                    
//                     <div className="d-flex align-items-center gap-3">
//                         {/* Notification Bell */}
//                         {/* <button className="btn btn-light rounded-circle position-relative p-2">
//                             <i className="ri-notification-3-line fs-5"></i>
//                             <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.6rem' }}>
//                                 3
//                             </span>
//                         </button> */}
                        
//                         {/* Profile Dropdown */}
//                         <div className="dropdown position-relative">
//                             <button 
//                                 className="btn d-flex align-items-center gap-2 border-0 bg-transparent p-2"
//                                 onClick={toggleProfileDropdown}
//                                 aria-expanded={showProfileDropdown}
//                                 aria-label="Profile menu"
//                             >
//                                 <div className="rounded-circle overflow-hidden" 
//                                      style={{ 
//                                          width: '40px', 
//                                          height: '40px', 
//                                          backgroundColor: '#4F46E5' 
//                                      }}>
//                                     <div className="w-100 h-100 d-flex align-items-center justify-content-center">
//                                         <i className="ri-user-line text-white fs-5"></i>
//                                     </div>
//                                 </div>
//                                 <span className="fw-semibold text-dark d-none d-md-inline">Customer</span>
//                                 <i className={`ri-arrow-down-s-line ${showProfileDropdown ? 'rotate-180' : ''}`}></i>
//                             </button>
                            
//                             {/* Dropdown Menu */}
//                             {showProfileDropdown && (
//                                 <>
//                                     {/* Backdrop to close dropdown when clicking outside */}
//                                     <div 
//                                         className="position-fixed top-0 start-0 w-100 h-100"
//                                         onClick={() => setShowProfileDropdown(false)}
//                                         style={{ zIndex: 1040 }}
//                                     ></div>
                                    
//                                     <div 
//                                         className="dropdown-menu show position-absolute end-0 mt-2 border-0 shadow-lg rounded-3"
//                                         style={{ 
//                                             minWidth: '220px', 
//                                             zIndex: 1050,
//                                             backgroundColor: '#fff'
//                                         }}
//                                     >
//                                         <div className="px-3 py-3 border-bottom">
//                                             <div className="d-flex align-items-center gap-3">
//                                                 <div className="rounded-circle overflow-hidden" 
//                                                      style={{ 
//                                                          width: '50px', 
//                                                          height: '50px', 
//                                                          backgroundColor: '#4F46E5' 
//                                                      }}>
//                                                     <div className="w-100 h-100 d-flex align-items-center justify-content-center">
//                                                         <i className="ri-user-line text-white fs-4"></i>
//                                                     </div>
//                                                 </div>
//                                                  <div>
//                                                     <h6 className="mb-0 fw-bold" style={{ fontSize: '0.85rem' }}>Customer User</h6>
//                                                     {/* <small className="text-muted" style={{ fontSize: '0.7rem' }}>admin@munnyfinds.com</small> */}
//                                                 </div>
//                                                 {/* <div>
//                                                     <h6 className="mb-0 fw-bold">John Doe</h6>
//                                                     <small className="text-muted">john@example.com</small>
//                                                 </div> */}
//                                             </div>
//                                         </div>
                                        
//                                         <div className="py-2">
//                                             <button 
//                                                 className="dropdown-item d-flex align-items-center py-2 px-3"
//                                                 onClick={handleProfileClick}
//                                             >
//                                                 <i className="ri-user-line me-3 text-primary"></i>
//                                                 <span>My Profile</span>
//                                             </button>
                                            
                                          
//                                            <button 
//                                                 className="dropdown-item d-flex align-items-center py-2 px-3"
//                                                 onClick={handleChangePassword}
//                                             >
//                                                 <i className="ri-user-line me-3 text-primary"></i>
//                                                 <span>Change Password</span>
//                                             </button>
                                            
                                            
                                            
//                                             <button 
//                                                 className="dropdown-item d-flex align-items-center py-2 px-3 text-danger"
//                                                 onClick={handleLogout}
//                                             >
//                                                 <i className="ri-logout-box-r-line me-3"></i>
//                                                 <span>Logout</span>
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Inline CSS for arrow rotation */}
//             <style>{`
//                 .rotate-180 {
//                     transform: rotate(180deg);
//                     transition: transform 0.3s ease;
//                 }
//                 .dropdown-item:hover {
//                     background-color: #f8f9fa;
//                     color: #4F46E5;
//                 }
//                 .dropdown-item:active {
//                     background-color: #4F46E5 !important;
//                     color: white !important;
//                 }
//             `}</style>
//         </nav>
//     );
// };

// export default CustomerHeader;
//web view 



import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const CustomerHeader = () => {
    const navigate = useNavigate();
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [isNavOpen, setIsNavOpen] = useState(false); // Added state to handle mobile menu

    const toggleProfileDropdown = () => {
        setShowProfileDropdown(!showProfileDropdown);
    };

    const handleLogout = () => {
        navigate('/');
    };

    const handleProfileClick = () => {
        navigate('/customer/profile');
        setShowProfileDropdown(false);
    };

    const handleChangePassword = () => {
        navigate('/customer/changepassword');
        setShowProfileDropdown(false);
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-2 py-md-3">
            <div className="container">
                {/* Brand Logo */}
                <Link className="navbar-brand d-flex align-items-center" to="/customer/orders" style={{ maxWidth: '65%' }}>
                    <svg
                        width="42"
                        height="42"
                        viewBox="0 0 180 120"
                        xmlns="http://www.w3.org/2000/svg"
                        className="brand-svg-mobile"
                        style={{ marginRight: '5px' }}
                    >
                        <text x="0" y="90" fontFamily="Playfair Display, Didot, serif" fontSize="96" fontWeight="700" letterSpacing="-10" fill="#111">MF</text>
                    </svg>
                    <div className="d-flex flex-column brand-text-mobile">
                        <span className="brand-title" style={{ fontSize: '0.9rem', fontWeight: '500', letterSpacing: '0.2rem', color: '#111', lineHeight: '1.1' }}>MUNNY FINDS</span>
                        <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.55rem', letterSpacing: '0.05rem' }}>Customer Control</span>
                    </div>
                </Link>

                <div className="d-flex align-items-center gap-1 order-lg-last">
                    {/* Profile Dropdown */}
                    <div className="dropdown position-relative">
                        <button 
                            className="btn d-flex align-items-center gap-1 border-0 bg-transparent p-1 p-md-2"
                            onClick={toggleProfileDropdown}
                        >
                            <div className="rounded-circle overflow-hidden" style={{ width: '32px', height: '32px', backgroundColor: '#4F46E5' }}>
                                <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                                    <i className="ri-user-line text-white fs-6"></i>
                                </div>
                            </div>
                            <span className="fw-semibold text-dark d-none d-md-inline ms-1" style={{ fontSize: '0.9rem' }}>Customer</span>
                            <i className={`ri-arrow-down-s-line small ${showProfileDropdown ? 'rotate-180' : ''}`}></i>
                        </button>
                        
                        {showProfileDropdown && (
                            <>
                                <div className="position-fixed top-0 start-0 w-100 h-100" onClick={() => setShowProfileDropdown(false)} style={{ zIndex: 1040 }}></div>
                                <div className="dropdown-menu show position-absolute end-0 mt-2 border-0 shadow-lg rounded-3" style={{ minWidth: '220px', zIndex: 1050, backgroundColor: '#fff' }}>
                                    <div className="px-3 py-3 border-bottom">
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                                                <i className="ri-user-line text-white"></i>
                                            </div>
                                            <h6 className="mb-0 fw-bold" style={{ fontSize: '0.85rem' }}>Customer User</h6>
                                        </div>
                                    </div>
                                    <div className="py-2">
                                        <button className="dropdown-item py-2 px-3" onClick={handleProfileClick}><i className="ri-user-line me-2 text-primary"></i> My Profile</button>
                                        <button className="dropdown-item py-2 px-3" onClick={handleChangePassword}><i className="ri-lock-line me-2 text-primary"></i> Password</button>
                                        <div className="dropdown-divider"></div>
                                        <button className="dropdown-item py-2 px-3 text-danger" onClick={handleLogout}><i className="ri-logout-box-r-line me-2"></i> Logout</button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Navbar Toggler - Updated with onClick */}
                    <button 
                        className="navbar-toggler border-0 p-1 ms-1" 
                        type="button" 
                        onClick={() => setIsNavOpen(!isNavOpen)}
                    >
                        <span className="navbar-toggler-icon" style={{ width: '1.2em', height: '1.2em' }}></span>
                    </button>
                </div>

                {/* Navbar Collapse - Updated with dynamic class */}
                <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="customerNavbar">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3 pt-3 pt-lg-0">
                         <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/customer/orders" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-shopping-bag-line me-2 d-lg-none"></i> My Orders
                            </Link>
                        </li>
                         <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/customer/appointments" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-calendar-line me-2 d-lg-none"></i> My Appointments
                            </Link>
                        </li>
                         <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/customer/products/search" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-store-2-line me-2 d-lg-none"></i> Products
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/customer/service" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-service-line me-2 d-lg-none"></i> Services
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark" to="/customer/salons/search" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-search-line me-2 d-lg-none"></i> Find Salons
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <style>{`
                .rotate-180 { transform: rotate(180deg); transition: transform 0.3s ease; }
                .dropdown-item:hover { background-color: #f8f9fa; color: #4F46E5; }
                @media (min-width: 992px) {
                    .brand-title { font-size: 1.05rem !important; letter-spacing: 0.35rem !important; }
                    .brand-svg-mobile { width: 52px !important; height: 52px !important; }
                }
                @media (max-width: 991px) {
                    .navbar-collapse.show {
                        display: block;
                        background: white;
                        padding-bottom: 20px;
                    }
                    .nav-item { border-bottom: 1px solid #eee; }
                }
            `}</style>
        </nav>
    );
};

export default CustomerHeader;



